const defaultMSFTWorkspaceData = {
  AzurePortalUrl: "https://ms.portal.azure.com/#@72f988bf-86f1-41af-91ab-2d7cd011db47/resource/subscriptions/dad45786-32e5-4ef3-b90e-8e0838fbadb6/resourceGroups/msft-experimentation-prod-rg/providers/Microsoft.Experimentation/experimentWorkspaces/msft/overview",
  Description: "ExP Classic Microsoft 1P Partners",
  ID: "microsoft",
  IsMsftWorkspace: true,
  IsVNextExpMan: false,
  Name: "microsoft",
  Path: "/",
  SubscriptionId: "dad45786-32e5-4ef3-b90e-8e0838fbadb6",
  TenantId: "72f988bf-86f1-41af-91ab-2d7cd011db47",
  WorkspacePath: "/subscriptions/dad45786-32e5-4ef3-b90e-8e0838fbadb6/resourceGroups/msft-experimentation-prod-rg/providers/Microsoft.Experimentation/experimentWorkspaces/msft"
};
export {
  defaultMSFTWorkspaceData
};
//# sourceMappingURL=defaultWorkspaceData.js.map
